import { render } from "./TheBikeTypes.vue?vue&type=template&id=99152ddc"
import script from "./TheBikeTypes.vue?vue&type=script&lang=js"
export * from "./TheBikeTypes.vue?vue&type=script&lang=js"

import exportComponent from "/workspace/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__